export default __webpack_public_path__ + "static/media/spinner-logo.0b3e234d.png";